import { ModalParamAppointmentCancellation } from '@agent/core/contact/appointment.service';
import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppointmentStatus } from '@commons/models/appointment';
import { first, map } from 'rxjs';

import { AppointmentFacade, Logger, ToasterFacade } from '@contact/upgrade';

@Component({
  selector: 'cng-appointment-cancellation-dialog',
  templateUrl: './appointment-cancellation-dialog.component.html',
  styleUrls: ['./appointment-cancellation-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppointmentCancellationDialogComponent implements OnInit {
  // resolve params (internal)
  private appointmentId: string;
  private status: AppointmentStatus;

  initDone: boolean = false;

  constructor(
    private readonly logger: Logger,
    private readonly appointmentFacade: AppointmentFacade,
    private readonly toasterFacade: ToasterFacade,
    private readonly dialogRef: MatDialogRef<AppointmentCancellationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private readonly data: any
  ) {
    this.logger = this.logger.forSource('AppointmentCancellationDialogComponent');
  }

  ngOnInit(): void {
    let param: ModalParamAppointmentCancellation = this.data;
    if (
      !!param &&
      !!param.appointmentId &&
      !!param.status &&
      param.status !== AppointmentStatus.CANCELLED &&
      param.status !== AppointmentStatus.REQUEST_CANCELLED
    ) {
      this.appointmentId = param.appointmentId;
      this.status = param.status;
      this.initDone = true;
    } else {
      this.logger.error('Missing params or params not utilisable for cancel the appointment');
    }
  }

  submitForm(): void {
    if (this.initDone) {
      this.appointmentFacade.cancel(this.appointmentId, this.status);
      this.toasterFacade.toasts$
        .pipe(
          first(),
          map(toasts =>
            toasts.filter(
              toast => toast.data && (toast.data as any).apointmentId && (toast.data as any).apointmentId === this.appointmentId
            )
          )
        )
        .subscribe(toasts => toasts.forEach(toast => this.toasterFacade.close(toast.id)));
      this.logger.debug('The appointment ' + this.appointmentId + ' is to be cancelled');
      this.close();
    }
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  close(): void {
    this.dialogRef.close(true);
  }
}
